export default __webpack_public_path__ + "static/media/Joan_Tretze.196c17e7.png";